import { storeToRefs } from 'pinia'
import { computed, toValue } from 'vue'

import { useReservationsStore } from '@/store/reservations'
import type { Reservation } from '@/types'

export function useReservations(reservationId: string) {
  const reservationsStore = useReservationsStore()
  const { reservations } = storeToRefs(reservationsStore)

  const reservation = computed<Reservation>(() => {
    const id = toValue(reservationId)
    return reservations.value[id]
  })

  const hasWarranty = computed(() => {
    return reservation.value.policy && reservation.value.policy !== 'none'
  })

  return {
    hasWarranty
  }
}
